import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Sobre el juego" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Este es un pequeño juego basado en Wordle sobre las escape rooms desarrollado por &nbsp;
        <a
          href="https://instagram.com/cazadoresdeescapes"
          className="underline font-bold"
        >
           Cazadores de escapes
        </a>{' '}
      </p>
    </BaseModal>
  )
}
